import { Observable } from 'rxjs';

export class MyEvent {
  public Id: string;
  public Subject: string;
  public EventStartDate: Date;
  public BodyPreview: string;
  public EventStartDateFormatted: string;
  public EventStartDateAllDayFormatted: string;
  public EventEndDate: Date;
  public EventEndDateFormatted: string;
  public EventEndDateAllDayFormatted: string;
  public Location: string;
  public Recurring: string;
  public WebLink: string;
  public IsAllDay: boolean;
  public IsMultipleDays: boolean;
  public Attendees: number;
  public Accepted: number;
  public Declined: number;
  public NoResponse: number;
  public Tentative: number;
  public Expired: boolean;
  public IsCancelled: boolean;
  public IsOrganizer: boolean;
  public Response: Response;
  public UserPhotos$: Observable<Array<string>>;

  constructor(opt?: Partial<MyEvent>) {
    Object.assign(this, opt);
  }
}

export enum Response {
  None = 1,
  Accepted = 2,
  Tentative = 3,
  Decline = 4
}
